var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('div',{staticClass:"container-wrap d-flex"},[_c(_vm.$route.name == 'form' ? 'payment-form' : 'switcher',{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }